<template>
    <div id="productListContainer">
        <Button class="btn-close" close @click="$emit('modalClosed')" />
        <div class="allproductRoas" @click="selectAllService"><span>全店</span></div>
        <div class="ServiceListContainer">
            <div class="selectedProduct">選択中店舗 : {{ selectedService.name }}</div>
            <div class="totallingTargetList">
                <transition-group tag="ul" :style="cssValueListColumn">
                    <li v-for="service in services" :key="service.id" class="totallingTargetItem"
                        :class="{ 'selected': selectedService.id == service.id }" @click="selectService(service)">
                        <div>{{ service.name }}
                        </div>
                        <div class="listItemAction">
                            <slot name="list-item-action" :service="service"></slot>
                        </div>
                    </li>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ShowService',
    props: {
        selectedService: Object,
        listColumn: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            services: [],
        }
    },
    mounted: function () {
        this.getServiceId();
    },
    methods: {
        getServiceId: function () {
            this.axios.get("/api/service/select/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                });
        },
        selectService(service) {
            this.$emit('input', service)
            this.$emit('modalClosed');
        },
        selectAllService() {
            const newArray = [{ id: -1, name: '全店' }];
            newArray.forEach(element => {
                this.$emit('input', element)
            });
            this.$emit('modalClosed');
        },
    },
    computed: {
        cssGridRows: function () {
            if (this.showSelected) {
                return `grid-template-rows: 44px 30px 1fr`;
            } else {
                return `grid-template-rows: 44px 1fr`;
            }
        },
        cssValueListColumn: function () {
            return `--column: ${this.listColumn}`;
        },
    }
}
</script>

<style scoped lang="sass">
#productListContainer
    padding: 15px
    height: 100%
    width: 100%
    .btn-close
        position: absolute
        top: 15px
        right: 15px
    .allproductRoas
        display: inline-flex;
        align-items: center;
        padding: 7px 24px;
        height: 40px;
        background: #f5f5f5;
        white-space: nowrap;
        cursor: pointer;
        color: $grayColor
        font-size: 1.5rem;
        margin-right: 55px
        float: right
        text-align:center
        border: 1px solid $mainColor
        &:hover
            background: $mainColor
            color: $whiteColor
            transition: 0.2s ease-out
    .ServiceListContainer
        padding: 0
        height: 90%
        width: 100%
        display: inline-grid
        grid-template-columns: 1fr
        grid-row-gap: 10px
        .selectedProduct
            border-bottom: 2px solid #E6E6E6
            color: $grayColor
            font-size: 1.5rem
            height: 30px
            margin: 0
            padding: 7px
            width: 30%
            min-width: 200px
        .totallingTargetList
            color: $grayColor
            font-size: 1.5rem
            overflow-y: scroll
            margin: 0
            padding: 0
            ul
                display: flex
                flex-wrap: wrap
                --column: 4
                li
                    overflow: hidden
                    display: inline-flex
                    align-items: center
                    margin: 2px
                    padding: 7px 2px
                    width: calc(100% / var(--column) - 4px)
                    height: 40px
                    background: #f5f5f5
                    white-space: nowrap
                    cursor: pointer
                    position: relative
                    &:hover
                        background: $mainColor
                        color: $whiteColor
                        transition: 0.2s ease-out
                    .listItemAction
                        position: absolute
                        right: 2px
                .selected
                    background: $mainColor
                    color: $whiteColor
            .totallingTargetItem
                padding: 10px
@include sp()
    #productListContainer
        .switchProductType
            position: relative
            top: 10px
            right: auto
            height: auto
            margin-right: 0
            margin-top: 11px
            float: none
        .ServiceListContainer
            margin-top: 30px
            .totallingTargetItem
                font-size: 12px
</style>
